import React, {FC, PropsWithChildren} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type HrWithTextProps = PropsWithChildren & {
	className?: string;
}

const HrWithText: FC<HrWithTextProps> = ({className, children}) => {
	return (
		<div className={classNames(styles.hrWithText, className)}>
			<hr />
			<span>{children}</span>
			<hr />
		</div>
	);
};

export const HrNoText: FC<HrWithTextProps> = ({className}) => (
	<div className={classNames(styles.hrWithText, className)}>
		<hr />
	</div>
);

export default HrWithText;
